
namespace GeniuzPOS.Administration {

    @Serenity.Decorators.registerClass()
    export class UserApprovalRoleDialog extends Serenity.EntityDialog<UserApprovalRoleRow, any> {
        protected getFormKey() { return UserApprovalRoleForm.formKey; }
        protected getIdProperty() { return UserApprovalRoleRow.idProperty; }
        protected getLocalTextPrefix() { return UserApprovalRoleRow.localTextPrefix; }
        protected getNameProperty() { return UserApprovalRoleRow.nameProperty; }
        protected getService() { return UserApprovalRoleService.baseUrl; }
        protected getDeletePermission() { return UserApprovalRoleRow.deletePermission; }
        protected getInsertPermission() { return UserApprovalRoleRow.insertPermission; }
        protected getUpdatePermission() { return UserApprovalRoleRow.updatePermission; }

        protected form = new UserApprovalRoleForm(this.idPrefix);

    }
}